jQuery(document).ready(function($) {
    $('.wp-block-query-filters').each(function() {
        const $block = $(this);
        const isInsideQueryLoop = $block.closest('.wp-block-query').length > 0;
        const isTermNavigation = $block.attr('data-term-navigation') === 'true';

        function getPostCards() {
            return isInsideQueryLoop
                ? $block.closest('.wp-block-query').find('.wp-block-post')
                : $('.wp-block-query').find('.wp-block-post');
        }

        // All-pill: clear filters (filter mode) or navigate to archive (nav mode)
        $block.on('click', '.is-all-pill', function(e) {
            e.preventDefault();
            if (isTermNavigation) {
                const url = $(this).data('url');
                if (url) window.location.href = url;
            } else {
                $block.find('input[type="checkbox"]').prop('checked', false);
                $block.find('select').val('');
                $block.find('.is-all-pill').addClass('is-active');
                getPostCards().show();
            }
        });

        if (isTermNavigation) {
            $block.on('click', '.term-item[data-term-url]', function(e) {
                e.preventDefault();
                window.location.href = $(this).data('term-url');
            });
        } else if ($block.hasClass('query-filters-dropdown')) {
            $block.find('.filter-action-search').on('click', function(e) {
                e.preventDefault();
                applyFilters();
            });
            $block.find('.filter-action-clear').on('click', function(e) {
                e.preventDefault();
                $block.find('select').val('');
                $block.find('.is-all-pill').addClass('is-active');
                getPostCards().show();
            });
        } else {
            $block.find('input[type="checkbox"]').on('change', function() {
                applyFilters();
            });
        }

        function applyFilters() {
            const active = {};
            let hasActive = false;

            if ($block.hasClass('query-filters-dropdown')) {
                $block.find('select').each(function() {
                    const tax = $(this).data('taxonomy');
                    const val = $(this).val();
                    if (val) { active[tax] = [val]; hasActive = true; }
                });
            } else {
                $block.find('[data-taxonomy]').each(function() {
                    const tax = $(this).data('taxonomy');
                    const slugs = [];
                    $(this).find('input[type="checkbox"]:checked').each(function() {
                        slugs.push($(this).val());
                    });
                    if (slugs.length) { active[tax] = slugs; hasActive = true; }
                });
            }

            $block.find('.is-all-pill').toggleClass('is-active', !hasActive);

            if (!hasActive) {
                getPostCards().show();
                return;
            }

            // WordPress adds "{taxonomy}-{term-slug}" CSS classes to every .wp-block-post
            getPostCards().each(function() {
                const $post = $(this);
                let visible = true;
                for (const [tax, slugs] of Object.entries(active)) {
                    if (!slugs.some(s => $post.hasClass(tax + '-' + s))) {
                        visible = false;
                        break;
                    }
                }
                $post.toggle(visible);
            });
        }
    });
});
